// src/userComponent/ViewAllCustomers.jsx
import { useState, useEffect } from "react";
import axios from "axios";
import React from "react";
import "../css/ViewAllCustomers.css"; // create or merge these styles into your main css
import { FaSearch } from "react-icons/fa";

const ViewAllDeliveryPerson = () => {
  const [allCustomer, setAllCustomer] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const admin_jwtToken = sessionStorage.getItem("admin-jwtToken");

  useEffect(() => {
    const getAllUsers = async () => {
      const allUsers = await retrieveAllUser();
      if (allUsers && Array.isArray(allUsers.users)) {
        setAllCustomer(allUsers.users);
        setFiltered(allUsers.users);
      } else {
        setAllCustomer([]);
        setFiltered([]);
      }
      setLoading(false);
    };

    getAllUsers();
  }, []);

  const retrieveAllUser = async () => {
    try {
      const response = await axios.get(
        "https://goldenhides.in/api/user/fetch/role-wise?role=Delivery",
        {
          // headers: { Authorization: "Bearer " + admin_jwtToken }
        }
      );
      return response.data;
    } catch (err) {
      console.error("fetch customers error", err);
      setLoading(false);
      return null;
    }
  };

  // simple search (name / email / phone)
  useEffect(() => {
    const term = (q || "").trim().toLowerCase();
    if (!term) {
      setFiltered(allCustomer);
      return;
    }
    const out = allCustomer.filter((c) => {
      const name = `${c.firstName || ""} ${c.lastName || ""}`.toLowerCase();
      const email = (c.emailId || "").toLowerCase();
      const phone = String(c.phoneNo || "");
      const addr =
        c.address && (c.address.street || c.address.city || c.address.pincode)
          ? `${c.address.street || ""} ${c.address.city || ""} ${
              c.address.pincode || ""
            }`.toLowerCase()
          : "";
      return (
        name.includes(term) ||
        email.includes(term) ||
        phone.includes(term) ||
        addr.includes(term)
      );
    });
    setFiltered(out);
  }, [q, allCustomer]);

  return (
    <div className="mt-3">
      <div className="container">
        <div className="card form-card custom-bg shadow-lg customers-card">
          <div className="card-header d-flex align-items-center justify-content-between bg-color custom-bg-text">
            <div>
              <h3 className="mb-0">All Delivery Persons</h3>
              <small className="text-muted">
                Manage registered delivery persons
              </small>
            </div>

            <div className="d-flex align-items-center gap-2">
              <div className="search-input-wrapper">
                <FaSearch className="search-icon" />
                <input
                  type="search"
                  placeholder="Search name, email, phone or address"
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  className="form-control small search-input"
                />
              </div>
            </div>
          </div>

          <div
            className="card-body"
            style={{
              minHeight: "20rem",
            }}
          >
            {loading ? (
              <div className="text-center py-5 text-muted">
                Loading customers...
              </div>
            ) : filtered.length === 0 ? (
              <div className="text-center py-5 text-muted">
                No customers found.
              </div>
            ) : (
              <div className="customers-grid">
                {filtered.map((customer) => {
                  const addressText = customer.address
                    ? `${customer.address.street || ""}, ${
                        customer.address.city || ""
                      } ${
                        customer.address.pincode
                          ? "- " + customer.address.pincode
                          : ""
                      }`
                    : null;

                  return (
                    <article
                      className="customer-card"
                      key={customer.id || customer.emailId}
                    >
                      <header className="customer-card-head">
                        <div className="avatar-circle">
                          {customer.firstName || customer.lastName ? (
                            <span className="avatar-initials">
                              {(customer.firstName || "U")
                                .charAt(0)
                                .toUpperCase()}
                              {(customer.lastName || "")
                                .charAt(0)
                                .toUpperCase()}
                            </span>
                          ) : (
                            <span className="avatar-initials">U</span>
                          )}
                        </div>
                        <div className="customer-meta">
                          <div className="customer-name">
                            {customer.firstName} {customer.lastName}
                          </div>
                          <div className="customer-email small text-muted">
                            {customer.emailId}
                          </div>
                        </div>
                        <div className="customer-badge small text-muted">
                          {customer.role || "Customer"}
                        </div>
                      </header>

                      <div className="customer-body">
                        <div className="info-row">
                          <div className="label">Phone</div>
                          <div className="value">{customer.phoneNo || "-"}</div>
                        </div>

                        <div className="info-row mt-2">
                          <div className="label">Address</div>
                          <div className="value address-muted">
                            {addressText || (
                              <span className="text-muted">No address</span>
                            )}
                          </div>
                        </div>
                      </div>

                      <footer className="customer-card-footer">
                        <div className="small text-muted">
                          Joined:{" "}
                          {customer.createdAt
                            ? new Date(
                                Number(customer.createdAt)
                              ).toLocaleDateString()
                            : "-"}
                        </div>
                        {/* future actions: view, edit, disable */}
                        <div className="card-actions">
                          <button className="btn btn-sm btn-outline-secondary">
                            View
                          </button>
                        </div>
                      </footer>
                    </article>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAllDeliveryPerson;
